// extracted by mini-css-extract-plugin
export default {"container":"ScanQr_container__hQ73Q","title":"ScanQr_title__9Aebl","image":"ScanQr_image__1Ni6O","pulse":"ScanQr_pulse__tJ12e"};